import React from 'react';
import { DollarSign, Calendar, TrendingUp } from 'lucide-react';

const LoanParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  investmentStrategies 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Начальная сумма инвестиций */}
      <div>
        <label htmlFor="initialInvestment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-2 text-indigo-500" />
          Начальная сумма инвестиций
        </label>
        <input
          type="text"
          id="initialInvestment"
          name="initialInvestment"
          value={formData.initialInvestment}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.initialInvestment ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.initialInvestment && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.initialInvestment}
          </p>
        )}
      </div>

      {/* Срок инвестирования */}
      <div>
        <label htmlFor="investmentTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Срок инвестирования (лет)
        </label>
        <input
          type="text"
          id="investmentTerm"
          name="investmentTerm"
          value={formData.investmentTerm}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.investmentTerm ? 'input-error' : ''}`}
          placeholder="Введите срок"
        />
        {errors.investmentTerm && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.investmentTerm}
          </p>
        )}
      </div>

      {/* Ежемесячный взнос */}
      <div>
        <label htmlFor="monthlyContribution" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-2 text-indigo-500" />
          Ежемесячный взнос
        </label>
        <input
          type="text"
          id="monthlyContribution"
          name="monthlyContribution"
          value={formData.monthlyContribution}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.monthlyContribution ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.monthlyContribution && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.monthlyContribution}
          </p>
        )}
      </div>

      {/* Тип инвестиционной стратегии */}
      <div>
        <label htmlFor="investmentType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип инвестиционной стратегии
        </label>
        <select
          id="investmentType"
          name="investmentType"
          value={formData.investmentType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.investmentType ? 'input-error' : ''}`}
        >
          {investmentStrategies.map((strategy) => (
            <option key={strategy.id} value={strategy.id}>
              {strategy.name}
            </option>
          ))}
        </select>
        {errors.investmentType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.investmentType}
          </p>
        )}
      </div>

      {/* Стратегия реинвестирования */}
      <div>
        <label htmlFor="reinvestmentStrategy" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <TrendingUp className="w-4 h-4 mr-2 text-indigo-500" />
          Стратегия реинвестирования
        </label>
        <select
          id="reinvestmentStrategy"
          name="reinvestmentStrategy"
          value={formData.reinvestmentStrategy}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          <option value="compound">Капитализация процентов</option>
          <option value="simple">Простое начисление</option>
        </select>
      </div>
    </div>
  );
};

export default LoanParametersSection;